const services = {
   "website-designer": {
    name: "Website Design",
    description: "High-fidelity digital design focused on conversion-centric layouts, surgical typography, and an uncompromising attention to visual hierarchy.",
    highlights: [
      "Responsive Fluid-Grid systems",
      "Interactive Prototyping",
      "Visual Brand Storytelling"
    ]
  },
  "website-design": {
    name: "Website Design",
    description: "High-fidelity digital design focused on conversion-centric layouts, surgical typography, and an uncompromising attention to visual hierarchy.",
    highlights: [
      "Responsive Fluid-Grid systems",
      "Interactive Prototyping",
      "Visual Brand Storytelling"
    ]
  },
  "web-development": {
    name: "Web Development",
    description: "Full-stack engineering for high-performance web applications, spanning from cloud infrastructure to front-end delivery.",
    highlights: [
      "Custom API & Database integration",
      "Serverless function architecture",
      "Automated CI/CD pipelines"
    ]
  },
  "react-architecture": {
    name: "React Architecture",
    description: "Modular component ecosystems with maintainable design tokens and high-performance hydration.",
    highlights: [
      "Component-level isolation",
      "Incremental adoption strategy",
      "Micro-frontend readiness"
    ]
  },
  "ui-ux-design": {
    name: "UI/UX Design",
    description: "Craft user journeys tuned for conversion and experiential storytelling across touchpoints.",
    highlights: [
      "Accessible typography scale",
      "UX audit with heuristic remediation",
      "A/B validated interactions"
    ]
  },
  "saas-product-development": {
    name: "SaaS Product Development",
    description: "Architecting scalable multi-tenant software solutions with robust authentication and state management.",
    highlights: [
      "Secure API integration",
      "Subscription model implementation",
      "Real-time data synchronization"
    ]
  },
  "ecommerce": {
    name: "E-commerce Architecture",
    description: "Building high-conversion headless commerce systems and custom Shopify Plus integrations.",
    highlights: [
      "Headless CMS implementation",
      "Secure payment gateway logic",
      "Conversion Rate Optimization (CRO)"
    ]
  },
  "ecommerce-architecture": {
    name: "E-commerce Architecture",
    description: "Building high-conversion headless commerce systems and custom Shopify Plus integrations.",
    highlights: [
      "Headless CMS implementation",
      "Secure payment gateway logic",
      "Conversion Rate Optimization (CRO)"
    ]
  },
  "web-performance-seo": {
    name: "Web Performance & SEO",
    description: "Technical SEO audits and performance tuning to crush Core Web Vitals and dominate search rankings.",
    highlights: [
      "Next.js SSG/ISR implementation",
      "Advanced caching strategies",
      "Semantic HTML5 & JSON-LD schemas"
    ]
  },
  "digital-strategy": {
    name: "Digital Strategy",
    description: "Twin Cities digital engagement frameworks built for local SEO authority and measurable growth.",
    highlights: [
      "Landing page engine",
      "Content cluster planning",
      "Performance and analytics alignment"
    ]
  },
  "brand-identity-systems": {
    name: "Brand Identity Systems",
    description: "Engineering digital-first visual languages that translate brand values into code-driven design systems.",
    highlights: [
      "Scalable SVG iconography",
      "Responsive motion guidelines",
      "Cross-platform design tokens"
    ]
  }
};

export default services;